import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import '../../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'pi/';
const rejectMessage = (error) => error.response?.data?.message || error.response?.data?.error || error.message || String(error);

export const getDraftGRNs = createAsyncThunk('PI/getDraftGRNs', async (_, thunkAPI) => {
    try { return (await axios.get(API_URL + 'getDraftPO')).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

export const getGRNDetails = createAsyncThunk('PI/getGRNDetails', async (pdID, thunkAPI) => {
    try { return (await axios.get(API_URL + `getPRDetails/${pdID}`)).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

export const getPIMasterData = createAsyncThunk('PI/getAll', async (_, thunkAPI) => {
    try { return (await axios.get(API_URL)).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

export const getPIData = createAsyncThunk('PI/getOne', async (piID, thunkAPI) => {
    try { return (await axios.get(`${API_URL}getpiData/${piID}`)).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

export const createPIMaster = createAsyncThunk('PI/saveMaster', async (data, thunkAPI) => {
    try { return (await axios.post(API_URL, data)).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

export const createPIDetail = createAsyncThunk('PI/saveDetails', async (data, thunkAPI) => {
    try { return (await axios.post(API_URL + 'detail/', data)).data; }
    catch (error) { return thunkAPI.rejectWithValue(rejectMessage(error)); }
});

const piSlice = createSlice({
    name: 'purchaseInvoice',
    initialState: { masterData: [], details: [], draftGRNs: [], isLoading: false, isError: false, message: '' },
    reducers: {},
    extraReducers: (builder) => {
        const pending = (state) => { state.isLoading = true; state.isError = false; state.message = ''; };
        const rejected = (state, action) => { state.isLoading = false; state.isError = true; state.message = action.payload; };
        builder
            .addCase(getDraftGRNs.pending, pending).addCase(getDraftGRNs.fulfilled, (state, action) => { state.isLoading = false; state.draftGRNs = action.payload; }).addCase(getDraftGRNs.rejected, rejected)
            .addCase(getPIMasterData.pending, pending).addCase(getPIMasterData.fulfilled, (state, action) => { state.isLoading = false; state.masterData = action.payload; }).addCase(getPIMasterData.rejected, rejected)
            .addCase(getPIData.pending, pending).addCase(getPIData.fulfilled, (state, action) => { state.isLoading = false; state.details = action.payload?.pi || []; }).addCase(getPIData.rejected, rejected)
            .addCase(getGRNDetails.pending, pending).addCase(getGRNDetails.fulfilled, (state) => { state.isLoading = false; }).addCase(getGRNDetails.rejected, rejected)
            .addCase(createPIMaster.pending, pending).addCase(createPIMaster.fulfilled, (state) => { state.isLoading = false; }).addCase(createPIMaster.rejected, rejected)
            .addCase(createPIDetail.pending, pending).addCase(createPIDetail.fulfilled, (state) => { state.isLoading = false; }).addCase(createPIDetail.rejected, rejected);
    }
});

export default piSlice.reducer;
